import React from 'react';
import img from '../../../assets/icons/payment-logos/webmoney.svg';
const WebMoney = () => {
  return (
    <img src={img} alt="/" />
  );
}

export default WebMoney;
